export default function Logo({ size = 'md' }) {
  const sizes = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl',
  }
  return (
    <span className={`font-black tracking-tight ${sizes[size]} text-white`}>
      Git<span style={{ color: '#10B981' }}>Craft</span>
    </span>
  )
}
